<!-- WDG-order-pay -->

<template>
  <div>
    <!-- WDG-order-pay -->
  </div>
</template>

<script>
import { ORDER_TYPE_WDG } from "@/api/constant";
import { Toast } from "vant";

export default {
  mounted() {
    this.go_select_card_pay();
  },

  methods: {
    go_select_card_pay() {
      Toast("去支付 ...")

      var queryString = "?cateId=" + this.$route.query.cateId 
        + "&WDG_order_sns=" + this.$route.query.WDG_order_sns + "&goodsType=" + ORDER_TYPE_WDG

      location.href = "/v6/select-card-pay" + queryString
    },
  },
};
</script>
